import * as React from "react";
import "./AiLeadsAction.css";
import Button from "@mui/material/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import StyledMenuInput from "../../StyledMenu/Index";
import {
  getConfidenceScore,
  GetStatsData,
} from "../../../Utils/Utils";
import { Tooltip } from "@mui/material";
import moment from "moment";
import FavoriteSearch from "../../FavoritesList/FavoritesListSearch/FavoriteSearch";
import { useLocation } from "react-router-dom";
export default function AiLeadsAction({
  profileData,
  currentLeadsLength,
  setDownloadToPDF,
  setIsSalesForceTrigger,
  isSalesForceTrigger,
  setIsDecisionMakerExcel,
  statsCount,
  statsCountDecisionMaker,
  setArchiveRecord,
  setUnArchivedRecord,
  disableTracking,
  setTrackRecord,
  setAddToFav,
  setRequestUpdateRecord,
  disableRequestUpdate,
  setShareRecord,
  showSalesForce,
  activeList,
  setActiveList,
  setActiveSearch,
  activeSearch,
  setLoading,
  loading,
  setSearchResultOrganization,
  searchResultPeople,
  setFavoriteSearchData,
  setSearchResultPeople,
  setRetrieveData,
  favoriteListMenuShow,
  setIsDecisionMakerExcelList,
  handleListExport,
  selectedOrganizationList,
  selectedProspectList,
  selectedOrganizationData,
  selectedProspectData,
  setheaderSearchData,
  setheaderSearchDataPeople,
  setOverviewPdfModal,
}) {
  const locationState = useLocation();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuSalesforce = () => {
    setIsSalesForceTrigger(true);
    setAnchorEl(null);
  };
  const handleMenuDownloadExcel = () => {
    setIsDecisionMakerExcel(true);
    setAnchorEl(null);
  };
  const handleMenuDownloadExcelList = () => {
    setIsDecisionMakerExcelList(true);
    setAnchorEl(null);
  };
  const handleMenuArchiveRecord = () => {
    setArchiveRecord(true);
    setAnchorEl(null);
  };
  const handleMenuUnArchiveRecord = () => {
    setUnArchivedRecord(true);
    setAnchorEl(null);
  };
  const handleMenuTrackRecord = () => {
    setTrackRecord(true);
    setAnchorEl(null);
  };
  const handleMenuAddToFav = () => {
    setAddToFav(true);
    setAnchorEl(null);
  };
  const handleMenuShareRecord = () => {
    setShareRecord(true);
    setAnchorEl(null);
  };
  const handleMenuRequestUpdateRecord = () => {
    setRequestUpdateRecord(true);
    setAnchorEl(null);
  };
  const handleAnchoElement = () => {
    setAnchorEl(null);
  };
  React.useEffect(() => {
    if (isSalesForceTrigger) {
      setIsSalesForceTrigger(false);
    }
  }, [isSalesForceTrigger]);
  const location = window?.location?.pathname;
  const statsData = GetStatsData();
  const handleProfileDetails = () => {
    setOverviewPdfModal(true);
    setAnchorEl(null);
  };
  return (
    <>
      <section
        className={
          location === "/favoritesList"
            ? "Leades-filter-drop-down-button-main-container-fav"
            : "Leades-filter-drop-down-button-main-container"
        }
      >
        <div
          className={
            location === "/favoritesList"
              ? "setProspects-Search-filter-favorite"
              : "setProspects-Search-filter"
          }
        >
          <div
            className={
              location === "/favoritesList"
                ? "showing-leads-head-fav"
                : "showing-leads-head"
            }
          >
            {location === "/Archived" ? <h3>Archived Records</h3> : null}
            {location?.includes("aiprofile") ? <h3>AI Profile</h3> : null}
            {location === "/people-results" ||
            location === "/organization-results" ? (
              <>
                <h3>Search Results</h3>
                <div className="psr-size">
                  {" "}
                  Search Inquiry: {locationState.state}
                </div>
              </>
            ) : null}
            {location?.includes("Profile") ? (
              <div>
                <h3>Prospect Details</h3>

                {/* <div className="data-sync-c-rate">
                    <div className="datasync-line-c-score">
                      <span className="datasync-line">Data Sync: </span  > <span className="datasync-line-data">{profileData?.updated_at ? moment(profileData.updated_at).format("MM.DD.YY") : "No update information available"}</span> </div>
                    <div className="datasync-line-c-score"> <span className="datasync-line">Data Confidence Score:</span>
                      <span className="datasync-line-data">{profileData?.confidence_score ? `${profileData.confidence_score * 10}%` : "No update information available"}</span></div>
                  </div> */}
              </div>
            ) : null}

            {location?.includes("companyprofilescreen") ? (
              <h3>Organization Details</h3>
            ) : null}
            {location === "/favorites" ? <h3>Favorites</h3> : null}
            {location === "/favorites" ? <h3>Favorites</h3> : null}
            {location === "/favoritesList" ? (
              <>
                <div className="fav-my-list-shared">
                  <FavoriteSearch
                    setheaderSearchData={setheaderSearchData}
                    setheaderSearchDataPeople={setheaderSearchDataPeople}
                    setRetrieveData={setRetrieveData}
                    activeList={activeList}
                    setActiveList={setActiveList}
                    setActiveSearch={setActiveSearch}
                    activeSearch={activeSearch}
                    setLoading={setLoading}
                    loading={loading}
                    setSearchResultOrganization={setSearchResultOrganization}
                    setSearchResultPeople={setSearchResultPeople}
                    setFavoriteSearchData={setFavoriteSearchData}
                    searchResultPeople={searchResultPeople}
                  />
                </div>{" "}
              </>
            ) : null}
            {location === "/dataenrich" ? <h3>Data Enrich</h3> : null}
            {currentLeadsLength && !statsCount && location === "/aileads" ? (
              <>
                <h3>
                  Showing {currentLeadsLength}{" "}
                  {location === "/aidecisionmakers" ? "Prospects " : "leads"}
                </h3>
                <p>
                  Out of{" "}
                  {location === "/aileads" || "/aiLeads"
                    ? statsData?.generated_leads.toLocaleString() || "-"
                    : null}
                </p>
              </>
            ) : null}
            {statsCount ? (
              <>
                <h3>
                  Showing {currentLeadsLength}{" "}
                  {location === "/aidecisionmakers" ? "Prospects " : "leads"}
                </h3>
                <p>
                  Out of{" "}
                  {location === "/aileads" || "/aiLeads" ? statsCount : null}
                </p>
              </>
            ) : null}
            {currentLeadsLength &&
            !statsCount &&
            location === "/aidecisionmakers" &&
            !statsCountDecisionMaker ? (
              <>
                <h3>
                  Showing {currentLeadsLength}{" "}
                  {location === "/aidecisionmakers" ? "Prospects " : "leads"}
                </h3>
                <p>
                  Out of{" "}
                  {location === "/aidecisionmakers"
                    ? statsData?.decisionmaker_count.toLocaleString() || "-"
                    : null}
                </p>
              </>
            ) : null}
            {statsCountDecisionMaker ? (
              <>
                <h3>
                  Showing {currentLeadsLength}{" "}
                  {location === "/aidecisionmakers" ? "Prospects " : "leads"}
                </h3>
                <p>
                  Out of{" "}
                  {location === "/aidecisionmakers"
                    ? statsCountDecisionMaker || "-"
                    : null}
                </p>
              </>
            ) : null}
          </div>
        </div>
        <div className="Leades-filter-inner-container">
          <Button
            id="action-button"
            aria-controls={open ? "action-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            variant="contained"
            disableElevation
            onClick={handleMenuClick}
            endIcon={<KeyboardArrowDownIcon />}
          >
            Action
          </Button>
          <StyledMenuInput
            handleMenuDownloadExcelList={handleMenuDownloadExcelList}
            disableTracking={disableTracking}
            handleProfileDetails={handleProfileDetails}
            anchorEl={anchorEl}
            open={open}
            handleAnchoElement={handleAnchoElement}
            handleMenuSalesforce={handleMenuSalesforce}
            handleMenuDownloadExcel={handleMenuDownloadExcel}
            handleMenuArchiveRecord={handleMenuArchiveRecord}
            handleMenuUnArchiveRecord={handleMenuUnArchiveRecord}
            handleMenuTrackRecord={handleMenuTrackRecord}
            handleMenuAddToFav={handleMenuAddToFav}
            handleMenuRequestUpdateRecord={handleMenuRequestUpdateRecord}
            disableRequestUpdate={disableRequestUpdate}
            handleMenuShareRecord={handleMenuShareRecord}
            showSalesForce={showSalesForce}
            favoriteListMenuShow={favoriteListMenuShow}
            handleListExport={handleListExport}
            selectedOrganizationList={selectedOrganizationList}
            selectedProspectList={selectedProspectList}
            selectedOrganizationData={selectedOrganizationData}
            selectedProspectData={selectedProspectData}
          />
        </div>
      
      </section>
      {location?.includes("Profile") ? (
        // <div>
        <div className="data-sync-c-rate">
          <div className="datasync-line-c-score">
            <span className="datasync-line">Data Sync: </span>
            <span className="datasync-line-data">
              {profileData?.updated_at
                ? moment(profileData.updated_at).format("MM.DD.YY")
                : "No update information available"}
            </span>
          </div>

          <div className="datasync-line-c-score">
            <Tooltip
              title={
                "This score reflects a combination of record completeness, freshness, and data source reliability."
              }
            >
              <span>
                <span className="datasync-line">Data Confidence Score:</span>
                <span className="datasync-line-data">
                  {profileData?.confidence_score
                    ? getConfidenceScore(profileData.confidence_score)
                    : "No update information available"}
                </span>
              </span>
            </Tooltip>
          </div>
        </div>
      ) : // </div>
      null}
    </>
  );
}
